import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Theme } from "@material-ui/core";
import { incidentSettings, overLoadedSettings } from "./calloutRequestedData";
import CalloutRequestedTopIcon from "./CalloutRequestedTopIcon";
import { ClassNameMap } from "@material-ui/styles";
import { Brightness1 } from "@material-ui/icons";

interface CalloutRequestedTopProps {
  isItIncident: boolean;
  cancelCallout: any;
  changeRequestCalloutType: any;
  onDone: any;
  isCallouFinished: boolean;
  wardName: string;
  locationName: string;
}

const useStyles = makeStyles<Theme, boolean>((theme) => ({
  button: {
    fontSize: 18,
    width: 211,
    height: 50,
    marginBottom: 18,
    borderBlockColor: "white",
    border: "1px solid",
    float: "right",
    lineHeight: "normal",

    "@media (max-width: 600px)": {
      fontSize: 13,
      width: 180,
      height: 41,
      marginBottom: 13,
    },
  },
  title: {
    fontSize: 46,
    marginBottom: 6,
    fontWeight: 900,
    fontFamily: "lato",
    lineHeight: "normal",
    textAlign: "left",

    "@media (max-width: 600px)": {
      fontSize: 23,
      marginBottom: 0,
    },
  },
  location: {
    fontSize: 36,
    fontWeight: 500,
    fontFamily: "lato",
    lineHeight: "normal",
    float: "left",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%",
    color: (props) => (props ? incidentSettings.color : overLoadedSettings.color),
  },
  doneButton: {
    fontSize: 18,
    height: 50,
    backgroundColor: "white",
    fontFamily: "lato",
    fontWeight: 700,
    padding: 0,
    color: "#071827",
    marginTop: 10,

    "@media (max-width: 1024px)": {
      width: 190,
    },
  },
  betweenLocationWardIcon: {
    width: 8,
    height: 8,
  },
  betweenLocationWardIconSpan: {
    display: "inline-block",
    overflow: "hidden",
    marginLeft: 20,
    marginRight: 20,
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
  },
  icon: {
    flex: "0 1 14%",

    "@media (max-width: 1024px)": {
      flex: "0 0 145px",
      display: "flex",
    },

    "@media (max-width: 600px)": {
      flex: "0 0 122px",
    },
  },
  titleTablesAndMobileOnly: {
    flex: "1 1 100%",
    display: "none",

    "@media (max-width: 1024px)": {
      display: "block",
      paddingBottom: 25,
    },
    "@media (max-width: 600px)": {
      display: "block",
      paddingBottom: 25,
    },
  },
  titleAndLocation: {
    flex: "1 0 64%",

    "@media (max-width: 1024px)": {
      display: "none",
    },
  },
  buttons: {
    flex: "0 1 22%",
    display: "flex",
    flexDirection: "column",

    "@media (max-width: 1024px)": {
      flex: "1 1 100%",
    },
  },
}));

const createBetweenLocationWardIcon = (classes: ClassNameMap) => (
  <span className={classes.betweenLocationWardIconSpan}>
    <Brightness1 className={classes.betweenLocationWardIcon} />
  </span>
);

const CalloutRequestedTop: React.FC<CalloutRequestedTopProps> = ({
  isItIncident,
  cancelCallout,
  changeRequestCalloutType,
  isCallouFinished,
  onDone,
  wardName,
  locationName,
}) => {
  const classes = useStyles(isItIncident);

  const topButton = isCallouFinished ? (
    <Button variant="contained" onClick={onDone} className={classes.doneButton}>
      Done
    </Button>
  ) : (
    <Button variant="outlined" className={classes.button} onClick={cancelCallout}>
      Cancel Callout
    </Button>
  );

  return (
    <div className={classes.container}>
      <div className={classes.titleTablesAndMobileOnly}>
        <div className={classes.title}>{isItIncident ? incidentSettings.title : overLoadedSettings.title}</div>
      </div>
      <div className={classes.wrapper}>
        <div className={classes.icon}>
          <CalloutRequestedTopIcon isItIncident={isItIncident} />
        </div>
        <div className={classes.titleAndLocation}>
          <div className={classes.title}>{isItIncident ? incidentSettings.title : overLoadedSettings.title}</div>
          <div className={classes.location}>
            {locationName}
            {wardName && createBetweenLocationWardIcon(classes)}
            {wardName}
          </div>
        </div>
        <div className={classes.buttons}>
          {topButton}
          {!isCallouFinished && (
            <Button variant="outlined" className={classes.button} onClick={changeRequestCalloutType}>
              {isItIncident ? incidentSettings.upgradeButtonName : overLoadedSettings.upgradeButtonName}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalloutRequestedTop;
